/**
 * 运营 - 自由职业者管理 - 自由职业者列表
 */
<template>
  <div class="freelancer-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者管理</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="姓名">
          <el-input
            v-model="formInline.name"
            placeholder="请输入姓名"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="证件号">
          <el-input
            v-model="formInline.idNumber"
            placeholder="请输入证件号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="formInline.mobile"
            placeholder="请输入手机号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="收款账号">
          <el-input
            v-model="formInline.receiveAccount"
            placeholder="请输入收款账号"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="签约状态">
          <el-select
            v-model="formInline.signStatus"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option
              v-for="item in signStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="formInline.signDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="search-date"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无自由职业者"
        style="width: 100%"
        border
      >
        <el-table-column prop="freelancerName" label="姓名" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.freelancerName)"
            >
              {{ scope.row.freelancerName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="identityDocumentTypeStr" label="证件类型" min-width="120" show-overflow-tooltip />
        <el-table-column prop="identityDocumentNumber" label="证件号" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.identityDocumentNumber)"
            >
              {{ scope.row.identityDocumentNumber || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.mobile)"
            >
              {{ scope.row.mobile || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="receiveAccount" label="收款账号" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.receiveAccount)"
            >
              {{ scope.row.receiveAccount || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="verificationStatusStr" label="实名认证状态" min-width="120">
          <template slot-scope="scope">
            <span :style="{ color: getVerificationStatusColor(scope.row.verificationStatus) }">
              {{ scope.row.verificationStatusStr || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="signStatusStr" label="签约状态" min-width="110">
          <template slot-scope="scope">
            <span :style="{ color: getSignStatusColor(scope.row.signStatus) }">
              {{ scope.row.signStatusStr || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="identityPhoto" label="证件照片" min-width="100">
          <template slot-scope="scope">
            <el-tag
              size="small"
              effect="plain"
              :type="scope.row.identityPhoto === '已上传' ? 'success' : 'info'"
            >
              {{ scope.row.identityPhoto || '--' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="faceAuthStatusStr"
          label="人脸认证状态"
          min-width="110"
        >
          <template slot-scope="scope">
            <span :style="{ color: getFaceAuthStatusColor(scope.row.faceAuthStatus) }">
              {{ scope.row.faceAuthStatusStr || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="merchantName" label="商户" min-width="140" show-overflow-tooltip />
        <el-table-column prop="distributeCompanyName" label="服务商" min-width="140" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
        <el-table-column prop="contractSignAtStr" label="签约时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contractSignAtStr || formatDateTime(scope.row.contractSignAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="createdAtStr" label="创建时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createdAtStr || formatDateTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedAtStr" label="更新时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.updatedAtStr || formatDateTime(scope.row.updatedAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              plain
              :loading="scope.row.deleting"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination';
import { freelancerslist, deleteFreelancer } from '../../api/userMG';

const SIGN_STATUS_LIST = [
  { label: '待签约', value: 0 },
  { label: '签约失败', value: 1 },
  { label: '任务待领取', value: 2 },
  { label: '签约成功', value: 3 },
  { label: '待人工审核', value: 4 },
  { label: '签约实效', value: 5 }
];

function createDefaultForm() {
  return {
    page: 1,
    pageSize: 10,
    name: '',
    idNumber: '',
    mobile: '',
    idType: '',
    verificationStatus: '',
    faceAuthStatus: '',
    receiveAccount: '',
    isPortraitPhoto: '',
    isIdentityPhoto: '',
    signStatus: '',
    updatedStartDate: '',
    updatedEndDate: '',
    signAtStartDate: '',
    signAtEndDate: '',
    signDate: []
  };
}

export default {
  name: 'OmsFreelancerList',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      formInline: createDefaultForm(),
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      signStatusList: SIGN_STATUS_LIST
    };
  },
  created() {
    this.getList();
  },
  methods: {
    buildQueryParams() {
      const params = { ...this.formInline };
      params.signAtStartDate = (params.signDate && params.signDate[0]) || '';
      params.signAtEndDate = (params.signDate && params.signDate[1]) || '';
      return params;
    },
    getList() {
      this.loading = true;
      freelancerslist(this.buildQueryParams())
        .then((res) => {
          if (res && res.msg === 'success') {
            const data = res.data || {};
            this.listData = data.items || data.list || data.records || [];
            this.pageparm.total = data.totalCount || data.total || data.count || 0;
            this.pageparm.page = data.page || this.formInline.page;
            this.pageparm.pageSize = data.pageSize || this.formInline.pageSize;
          } else {
            this.listData = [];
            this.pageparm.total = 0;
            this.$message.error((res && (res.msg || res.message)) || '获取自由职业者列表失败');
          }
        })
        .catch((err) => {
          this.listData = [];
          this.pageparm.total = 0;
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取自由职业者列表失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline = createDefaultForm();
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '--';
      const timestampMs = String(timestamp).length <= 10 ? timestamp * 1000 : timestamp;
      const date = new Date(timestampMs);
      if (Number.isNaN(date.getTime())) return '--';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    getSignStatusColor(status) {
      switch (status) {
        case 0:
        case 6:
          return '#409EFF';
        case 3:
          return '#67C23A';
        case 5:
          return '#909399';
        case 1:
        case 2:
          return '#F56C6C';
        case 4:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    getVerificationStatusColor(status) {
      switch (status) {
        case 2:
        case 7:
          return '#409EFF';
        case 3:
          return '#67C23A';
        case 6:
          return '#909399';
        case 1:
          return '#F56C6C';
        case 4:
        case 5:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    getFaceAuthStatusColor(faceAuthStatus) {
      switch (faceAuthStatus) {
        case 0:
        case 1:
          return '#409EFF';
        case 2:
          return '#67C23A';
        case 3:
          return '#F56C6C';
        case 4:
          return '#E6A23C';
        default:
          return '#303133';
      }
    },
    handleDelete(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录信息不完整，无法删除');
        return;
      }
      const name = row.freelancerName || '该自由职业者';
      this.$confirm(`确定删除自由职业者「${name}」吗？删除后不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$set(row, 'deleting', true);
          deleteFreelancer({ id: row.id })
            .then((res) => {
              if (res && res.msg === 'success') {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error((res && (res.msg || res.message)) || '删除失败');
              }
            })
            .catch((err) => {
              const data = err && err.response && err.response.data;
              this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '删除失败');
            })
            .finally(() => {
              this.$set(row, 'deleting', false);
            });
        })
        .catch(() => {});
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(str)
          .then(() => {
            this.$message.success('已复制');
          })
          .catch(() => {
            this.fallbackCopy(str);
          });
      } else {
        this.fallbackCopy(str);
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>
.freelancer-list-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.search-form .search-date {
  width: 240px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.copyable-cell {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/freelancerList.vue